import React, { memo } from "react";
import PropTypes from "prop-types";
import {
  Icon,
  Menu,
  MenuItem,
  MenuList,
  MenuButton,
  IconButton,
} from "@chakra-ui/react";
import { FaEllipsisV, FaPen, FaTrash } from "react-icons/fa";
import { translate as trans } from "../Trans/Trans";

const PostsBulkImportItemMenu = ({
  buttonProps,
  onDelete,
  onEdit,
  ...rest
}) => (
  <Menu isLazy minWidth="6" autoSelect={false} {...rest}>
    <MenuButton
      variant="ghost"
      as={IconButton}
      icon={<FaEllipsisV />}
      aria-label="Options"
      {...buttonProps}
      onClick={(e) => e.stopPropagation()}
    />
    <MenuList
      w="130px"
      minW="130px"
      fontSize="xs"
      onClick={(e) => e.stopPropagation()}
    >
      {onEdit && (
        <MenuItem onClick={onEdit} icon={<Icon fontSize="sm" as={FaPen} />}>
          {trans("posts.edit")}
        </MenuItem>
      )}
      {onDelete && (
        <MenuItem onClick={onDelete} icon={<Icon fontSize="sm" as={FaTrash} />}>
          {trans("posts.delete")}
        </MenuItem>
      )}
    </MenuList>
  </Menu>
);

PostsBulkImportItemMenu.propTypes = {
  buttonProps: PropTypes.object,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
  onUse: PropTypes.func,
};

PostsBulkImportItemMenu.defaultProps = {
  buttonProps: undefined,
  onDelete: undefined,
  onEdit: undefined,
  onUse: undefined,
};

export default memo(PostsBulkImportItemMenu);
